<template>
  <div>
    <b-container>
      <div class="whitespace" style="height:50px;"></div>
      <transition name="fade">
      </transition>

      <b-row style="margin-top:15px;">
        <b-col sm="10">
          <div class="name" style="margin-left:80px;">
            <h4 style="margin-bottom:30px">Редактирование профиля</h4>
            <transition name="fade">
              <b-form-input type="text" :hidden='true' v-model="form.email" ></b-form-input>
            </transition>
            <transition name="fade">
              <b-form-input type="text" v-model="form.first_name" ></b-form-input>
            </transition>
            <transition name="fade">
              <b-form-input
                type="text"
                v-model="form.last_name"
                v-if="form.first_name"
                placeholder="Введите фамилию"
              ></b-form-input>
            </transition>
            <transition name="fade">
              <toggle-switch v-if="form.first_name && form.last_name" :options="myOptions" v-model="form.gender" />
            </transition>

            <transition name="fade" >
              <div v-if="form.first_name && form.last_name && form.gender && form.gender == 'М'" style="margin-bottom:20px; margin-top:30px;">
                <label for="" style="display:block"><b>Выберите аватар</b></label>
                <img :src="'//api.game.skillslab.center/media/avatars/man' +index +'.png'" alt="" class="person_icon" :class="{'big':index==form.icon}" v-for="index in 12" :key="index" @click="form.icon = index">
              </div>
              <div v-if="form.first_name && form.last_name && form.gender && form.gender == 'Ж'" style="margin-bottom:50px; margin-top:30px;">
                <label for="" style="display:block">Выберите аватар</label>
                <img :src="'//api.game.skillslab.center/media/avatars/woman' +index + '.png'" class="person_icon" :class="{'big':index==form.icon}" v-for="index in 12" :key="index" @click="form.icon = index">
              </div>
            </transition>
            <transition name="fade" v-if="form.first_name && form.last_name && form.gender && form.icon>0">
             <b-button @click="onSubmit" variant="primary" block style="margin-bottom: 30px; color:white">Готово</b-button>
            </transition>
          </div>
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>

import Story from "@/components/Story.vue";
export default {
    
  name: "EditUser",
  components: {
    Story
  },
  data() {
    return {
      selected: false,
      form: {
        last_name: this.$store.getters.userData.last_name,
        email: this.$store.getters.userData.email,
        first_name: this.$store.getters.userData.first_name,
        icon: this.$store.getters.userData.icon.split('/').pop().match(/\d+/g)[0],
        gender: this.$store.getters.userData.gender==1?'М':'Ж',
      },

      myOptions: {
        layout: {
          color: "black",
          backgroundColor: "white",
          selectedColor: "white",
          selectedBackgroundColor: "#3A97BF",
          fontWeight: "normal",
          fontSize: 12,
          fontWeightSelected: "bold",
          squareCorners: false,
          noBorder: false
        },
        size: {
          fontSize: 1,
          height: 2.3
        },
        items: {
          delay: 0.4,
          preSelected: "unknown",
          disabled: false,
          labels: [
            { name: "Ж", color: "white", backgroundColor: "#3A97BF" },
            { name: "М", color: "white", backgroundColor: "#3A97BF" }
          ]
        }
      },

       mounted() {
            if (this.$store.getters.userData.first_name){
                form.gender = "M"
            } else {
                form.gender = "Ж"
            }
       }
    };
  },
  mounted() {

  },
  methods: {
     getImgUrl(pet) {
      var images = require.context('../assets/avatars', false, /\.png$/)
      return images('./' + pet + ".png")
    },
    onSubmit() {

      this.$store.dispatch("makeUser", {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        gender: this.form.gender,
        icon: this.form.icon, 
        email: this.form.email
      });
    }
  }
};
</script>

<style scoped>
.toggle-switch label
{
  line-height: 1.4 !important;
}
.person_icon
{
  width:90px;
  margin-bottom: 10px;
  cursor: pointer;
  
}
.big.person_icon
{
  width:130px ;
  
}
.card {
  margin: auto;
  margin-top: 5em;
  box-shadow: 1.5px 1px 10px rgba(228, 229, 247, 0.5);
}
.alert {
  margin-top: 1em;
  margin-left: 5em;
  margin-right: 5em;
  max-width: 40rem;
}
.image {
  background-color: rgb(255, 255, 255);
  border: none;
  border-radius: 50%;
}
.but {
  margin-top: 10px;
  background-color: none;
  color: none;
  border: none;
}

.welcome {
  font-family: "Roboto", sans-serif;
  font-style: bold;
  font-weight: 500;
  font-size: 33px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.name input {
  margin-bottom: 10px;
}
</style>